import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useEffect } from "react";

import { ISoccerMatch } from "../../../types";
import { getMatch } from "../api";
import { appController } from "../stores/useAppStore";
import { pollIntervalMs } from "../utils/refreshCadence";

export const useSoccerMatch = ({
  matchId,
  kickoffTime,
}: {
  matchId?: string;
  kickoffTime?: string;
}): Pick<
  UseQueryResult<ISoccerMatch>,
  "data" | "isPending" | "error" | "refetch"
> => {
  const { isPending, error, data, refetch } = useQuery({
    queryKey: [`fixture-${matchId}`],
    queryFn: () => getMatch({ matchId: matchId as string, liveScore: true }),
    enabled: !!matchId?.length,
    // refetchInterval drives freshness; staleTime dedupes re-mount fetches.
    staleTime: 10_000,
    refetchInterval: () => pollIntervalMs("match", kickoffTime),
  });

  useEffect(() => {
    if (data) {
      const previousMatchData = appController.getState("matchData");
      if (!data.scores) {
        const liveData = { ...data, score: previousMatchData?.scores };
        appController.updateMatchData(liveData);
        return;
      }
      appController.updateMatchData(data);
    }
  }, [data]);

  return {
    isPending,
    error,
    data,
    refetch,
  };
};
